<template>
  <div class="exam-uniform-schedule-room-student-seat-no">
    <div class="value">{{cellValue}}</div>
    <div class="extra">
      <el-popover v-model="visible"
                  width="180px"
                  placement="left"
                  popper-class="exam-uniform-schedule-room-student-seat-no-popper">
        <div class="form-wrap">
          <div class="body">
            <el-form size="mini"
                     label-width="60px">
              <el-form-item label="座位号：">
                <el-input-number v-model="form.seatNo"
                                 controls-position="right"
                                 :min="1"
                                 :step="1"
                                 :precision="0"></el-input-number>
              </el-form-item>
            </el-form>
          </div>
          <div class="footer">
            <el-button size="mini"
                       type="primary"
                       :loading="committing"
                       @click="handleApply">确定</el-button>
            <el-button size="mini"
                       type="default"
                       @click="handleClose">取消</el-button>
          </div>
        </div>
        <el-button slot="reference"
                   size="mini"
                   type="text"
                   icon="el-icon-edit"></el-button>
      </el-popover>
    </div>
  </div>
</template>

<script>
import objectUtils from '../../../../../../../../../../../util/objectUtils'
export default {
  name: 'ExamUniformScheduleRoomStudentSeatNo',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    cellValue: [String, Number],
    cellParam: Object
  },
  data () {
    return {
      visible: false,
      form: {
        seatNo: undefined
      },
      committing: false
    }
  },
  methods: {
    handleApply () {
      if (typeof this.form.seatNo !== 'number') {
        this.$message.warning('请设置座位号')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/exam/uniform/schedule/room/student/seatNo',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          studentId: this.rowData.id
        }, this.cellParam, this.form))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success('座位号修改成功')
              this.visible = false
              this.$nextTick(() => {
                this.$emit('reloadGridData')
              })
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.visible = false
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          const value = this.cellValue
          if (objectUtils.hasValue(value)) {
            this.form.seatNo = Number(value)
          } else {
            this.form.seatNo = undefined
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../../../../styles/color";
  .exam-uniform-schedule-room-student-seat-no {
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > .value {
      &:empty {
        &:before {
          content: '\672a\5b89\6392';
          color: $set-empty-color;
        }
      }
    }
    & > .extra {
      margin-left: 5px;
    }
  }
  .exam-uniform-schedule-room-student-seat-no-popper {
    .form-wrap {
      & > .body {
        padding: 5px;
        .el-form {
          .el-form-item {
            &:last-child {
              margin-bottom: 0;
            }
            .el-form-item__label {
              font-size: 12px;
              padding-right: 0;
            }
            .el-form-item__content {
              .el-input-number {
                width: 80px;
                .el-input__inner {
                  text-align: left;
                  padding-left: 10px;
                  padding-right: 35px;
                }
              }
            }
          }
        }
      }
      & > .footer {
        margin-top: 10px;
        text-align: center;
        .el-button {
          padding: 5px 12px;
        }
      }
    }
  }
</style>
